import React from 'react';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../../fx/FxLog';
import * as FxFetch from '../../../fx/FxFetch';
import { useTranslation } from '../../../hx/useTranslation';
import CxDialog from '../../../cx/CxDialog';
import CxInput from '../../../cx/CxInput';
import CxSnackbar from '../../../cx/CxSnackbar';
import CxDlgAlert from '../../../cx/CxDlgAlert'; // Importación de la alerta
import '../../../../styles/main.css';


const MxClientOTF = (props) => {
  const [{ trans }] = useTranslation();
  const [dlg, setDlg] = React.useState(false);
  const [disabled, ] = React.useState(false);

  const rf_txClient = React.useRef(null);
  const rf_txIc = React.useRef(null);
  const rf_txAddress = React.useRef(null);
  const rf_txCity = React.useRef(null);
  const rf_txState = React.useRef(null);
  const rf_txPostalCode = React.useRef(null);
  const rf_txMobile = React.useRef(null);
  const rf_txEmail = React.useRef(null);

  const r_snack_required = React.useRef(null);
  const r_snack_exists = React.useRef(null);
  
  // Referencia para el diálogo de espera
  const r_dlg_alert = React.useRef(null);

  React.useEffect(() => {
    formLoad();
    // eslint-disable-next-line
  }, []);

  React.useImperativeHandle(props.xref, () => {
    return {
      setDlg,
    };
  });

  const formLoad = async () => {
  }

  const formSave = async () => {
    // Validaciones
    if (rf_txClient.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txClient.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }

    // --- INICIO PROCESO GUARDADO ---
    
    // Ocultamos la ventana principal y bloqueamos campos
    setDlg(false);

    // Mostramos cartel de espera
    r_dlg_alert.current.setText(trans('msg.saving'));
    r_dlg_alert.current.setProgressMsg(trans('msg.please_wait'));
    r_dlg_alert.current.setTextColor('var(--ibs_color_blue)');
    r_dlg_alert.current.setHasButtonClose(false);
    r_dlg_alert.current.setOpen(true);

    let txClient = rf_txClient.current.getVal();
    let txIc = rf_txIc.current.getVal();
    let txAddress = rf_txAddress.current.getVal();
    let txCity = rf_txCity.current.getVal();
    let txState = rf_txState.current.getVal();
    let txPostalCode = rf_txPostalCode.current.getVal();
    let txMobile = rf_txMobile.current.getVal();
    let txEmail = rf_txEmail.current.getVal();

    let record = {};
    record['txClient'] = txClient;
    record['txIc'] = txIc;
    record['txAddress'] = txAddress;
    record['txCity'] = txCity;
    record['txState'] = txState;
    record['txPostalCode'] = txPostalCode;
    record['txMobile'] = txMobile;
    record['txEmail'] = txEmail;

    Promise.all([FxFetch.doJsonX("clients/otf", record)]).then((result) => {
      // Cerramos siempre el cartel de espera al recibir respuesta
      r_dlg_alert.current.setOpen(false);

      FxLog.infox("MxClientOTF.formSave", "...result[0]:", result[0]);
      if (result[0]) {
        if (result[0].theValue === null) {
          // Si ya existe, reabrimos la ventana y notificamos
          setDlg(true);
          r_snack_exists.current.setVal(trans('msg.x_exists','field.client'));
          r_snack_exists.current.setOpen(true);
        } else {
          // Éxito
          let inClient = result[0].theValue;
          if (props.onOk) props.onOk(inClient, txClient);
        }
      }
    }).catch((error) => {
      // Error de red/servidor: Cerramos espera, reabrimos ventana y logueamos
      r_dlg_alert.current.setOpen(false);
      setDlg(true);
      FxLog.errorx("MxClientOTF.formSave", error);
    });
  }

  return (
    <div>
      <CxDialog title={trans('field.create_x','field.client')} open={dlg} onOk={formSave} onClose={() => setDlg(false)} >
          <CxInput xref={rf_txClient} label={trans('field.client')} disabled={disabled} width='var(--ibs_control_width_md)' maxLength={100} required />
          <CxInput xref={rf_txIc} label={trans('field.ic')} disabled={disabled} width='var(--ibs_control_width_md)' maxLength={15} />
          <CxInput xref={rf_txAddress} label={trans('field.address')} disabled={disabled} width='var(--ibs_control_width_md)' maxLength={100} />
          <CxInput xref={rf_txCity} label={trans('field.city')} disabled={disabled} width='var(--ibs_control_width_md)' maxLength={50} />
          <CxInput xref={rf_txState} label={trans('field.state')} disabled={disabled} width='var(--ibs_control_width_md)' maxLength={50} />
          <CxInput xref={rf_txPostalCode} label={trans('field.postal_code')} disabled={disabled} width='var(--ibs_control_width_md)' maxLength={10} />
          <CxInput xref={rf_txMobile} label={trans('field.mobile')} disabled={disabled} width='var(--ibs_control_width_md)' maxLength={50} />
          <CxInput xref={rf_txEmail} label={trans('field.email')} disabled={disabled} width='var(--ibs_control_width_md)' maxLength={255} />
      </CxDialog>

      {/* Alerta para bloqueo visual */}
      <CxDlgAlert xref={r_dlg_alert} />

      <CxSnackbar xref={r_snack_required} severity="error" />
      <CxSnackbar xref={r_snack_exists} severity="error" />
    </div>
  );
}

export default MxClientOTF;